import React from "react";
import "./App.css";
// import Dashboard from "./Dashboard";
import Footer from "./Footer";
import Header from "./Header";
import MainPage from "./MainPage";
// import Router from "./Router";
import SideBar from "./SideBar";
import Login from "./Pages/Login/Login";
import axios from "axios";
import { AppContext } from "./Lib/ContextLib";

import "react-toastify/dist/ReactToastify.css";

import { ToastContainer } from "react-toastify";
import { Routes, Route, Navigate } from "react-router-dom";
import { API_URL } from "./config";
import Contactus from "./Pages/Contactus/Contactus";
import ChangePassword from "./Pages/ChangePass/ChangePassword";
import ForgotPassword from "./Pages/ForgotPass/ForgotPassword";
import ChangeEmail from "./Pages/ChangeEmail/ChangeEmail";
import StripePayment from "./Pages/Stripe/Stripe-Payment";
import Sucess from "./Pages/Stripe/Sucess";
import Cancel from "./Pages/Stripe/Cancel";
import socketIO from "socket.io-client";
import { toast } from "react-toastify";
import CommandPalette from "./Components/CommandPalette";

// Set axios defaults globally and immediately
const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["token"] = token;
}

function App() {
  const socket = React.useMemo(
    () => socketIO(API_URL, {
      transports: ["websocket"],
      query: {
        isAdmin: "true",
        adminId: (() => {
          try {
            const token = localStorage.getItem("token");
            return token ? JSON.parse(atob(token.split(".")[1])).user || "" : "";
          } catch (e) {
            return "";
          }
        })()
      }
    }),
    []
  );

  let Authenticated = localStorage.getItem("user");
  const [isAuthenticated, setAuthenticated] = React.useState(!!Authenticated && !!localStorage.getItem("token"));
  const [showPage, setShowPage] = React.useState(false);
  const [accessObject, setAccessOject] = React.useState(() => {
    try {
      const user = localStorage.getItem("user");
      return user ? JSON.parse(user) : {};
    } catch (e) {
      return {};
    }
  });
  const [expand, setExpand] = React.useState();
  const [addNewPlayer, setAddNewPlayer] = React.useState(false);
  const [isValid, setIsValid] = React.useState(false);
  const [showCommandPalette, setShowCommandPalette] = React.useState(false);

  React.useEffect(() => {
    if (Authenticated && localStorage.getItem("token")) {
      setAuthenticated(true);
    } else {
      setAuthenticated(false);
    }
  }, []);

  React.useEffect(() => {
    const handleReceiveMessage = (data) => {
      console.log("receive_message_admin app...", data);
    };
    socket.on("receive_message_admin", handleReceiveMessage);
    return () => {
      socket.off("receive_message_admin", handleReceiveMessage);
    };
  }, [socket]);

  return (
    <div className="wrapper">
      <ToastContainer />
      <AppContext.Provider
        value={{
          isAuthenticated,
          setAuthenticated,
          showPage,
          setShowPage,
          accessObject: new Proxy(accessObject || {}, {
            get: (target, prop) => {
              if (prop === "access") {
                return new Proxy(target.access || {}, {
                  get: (nestedTarget, nestedProp) => {
                    const role = target.role !== undefined ? Number(target.role) : (Array.isArray(target.access) ? 1 : 0);
                    if (role === 0) return true;
                    if (role === 1) {
                      if (Array.isArray(target.access)) {
                        return target.access.includes(nestedProp);
                      }
                      if (typeof target.access === "object" && target.access !== null) {
                        return target.access[nestedProp] === true || target.access[nestedProp] === "true";
                      }
                    }
                    return false;
                  },
                });
              }
              if (typeof prop === "symbol" || prop === "toJSON" || prop === "then") {
                return target[prop];
              }
              const metadataKeys = [
                "_id",
                "id",
                "name",
                "userName",
                "email",
                "phoneNo",
                "token",
                "createdAt",
                "updatedAt",
                "role",
              ];
              if (metadataKeys.includes(prop)) {
                return target[prop];
              }

              // Fallback: If localStorage only has the access array (from old buggy Login.js)
              if (Array.isArray(target)) {
                return target.includes(prop);
              }

              const role = target.role !== undefined ? Number(target.role) : (Array.isArray(target.access) ? 1 : 0);
              if (role === 0) return true;
              if (role === 1) {
                if (Array.isArray(target.access)) {
                  return target.access.includes(prop);
                }
                if (typeof target.access === "object" && target.access !== null) {
                  return target.access[prop] === true || target.access[prop] === "true";
                }
              }
              return false;
            },
          }),
          setAccessOject,
          expand,
          setExpand,
          addNewPlayer,
          setAddNewPlayer,
          isValid,
          setIsValid,
          showCommandPalette,
          setShowCommandPalette,
          socket,
        }}
      >
        {isAuthenticated ? (
          <div className="wrapper">
            <Header />
            <SideBar />
            <CommandPalette />
            <MainPage />
            <Footer />
          </div>
        ) : (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/payment" element={<StripePayment />} />
            <Route path="/sucess" element={<Sucess />} />
            <Route path="/cancel" element={<Cancel />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/change-email" element={<ChangeEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
            <Route path="/contact-us" element={<Contactus />} />
          </Routes>
        )}
      </AppContext.Provider>
    </div>
  );
}

export default App;
